/**
 * Translation layer for legacy functions that can be called via `optimizely.push([methodName, arg1, arg2])`
 * @module
 */
var _ = require('optimizely-client-fn');

var v1 = require('./v1');

/*
exports.activate = function() {
  // TODO(tyler)
};
*/

/**
 * This is the name geo4.js uses
 * @param {Object} data
 * @param {string} [source]
 */
exports.activateGeoDelayedExperiments = function(data:any, source?:string) {
  if (!source) {
    // Legacy Akamai/ODDS do not provide source
    source = data.lists ? 'odds' : 'cdn3';
  }

  v1.dataFromSource({
    data: data,
    source: source,
  });
};

/**
 *
 * @param {Object} [settings]
 * @param {Object} settings.sVariable Reference to customer-defined sVariable
 */
exports.activateSiteCatalyst = function(settings?:any) {
  if (!settings || !settings.sVariable) {
    return;
  }

  v1.integrationSettings({
    id: 'adobe_analytics',
    settings: {
      sVariableReference: settings.sVariable,
    },
  });
};

/*
exports.activateUniversalAnalytics = function() {
  // TODO(tyler)
};
*/

/*
exports.addToAudience = function() {
  // TODO(tyler)
};
*/

/*
exports.bindTrackElement = function() {
  // TODO(tyler)
};
*/

/**
 * Uses bucketVisitor in v1
 * @param {number|string} experimentId
 * @param {number|string} variationIdOrIndex ID or index in the variations list to bucket the user into
 */
exports.bucketVisitor = function(experimentId:number|string, variationIdOrIndex:number|string) {
  if (!experimentId || !variationIdOrIndex) {
    return;
  }

  var bucketingData: any = {
    experimentId: String(experimentId),
  };

  // Like legacy bucketUser, (https://github.com/optimizely/optimizely/blob/be7a940e79138d9ee0f2f2f0b009104d66de9270/src/www/js/client/api.js#L182)
  // assume a number greater than 256 is an ID, and less than or equal to is an index
  if (variationIdOrIndex > 256) {
    bucketingData.variationId = String(variationIdOrIndex);
  } else {
    bucketingData.variationIndex = String(variationIdOrIndex);
  }

  v1.bucketVisitor(bucketingData);
};

exports.bucketUser = exports.bucketVisitor;


/*
exports.clickTaleRecord = function() {
  // TODO(tyler)
};
*/

/*
exports.clickTalePlayback = function() {
  // TODO(tyler)
};
*/

/*
exports.customTag = function() {
  // TODO(tyler)
};
*/

/*
exports.delayDomReadyEval = function() {
  // TODO(tyler)
};
*/

/*
exports.delayPageviewTracking = function() {
  // TODO(tyler)
};
*/

/**
 * @param {string} [type] - If "tracking", only disable tracking events. Otherwise disable everything.
 */
exports.disable = function(type?:string) {
  v1.disable({scope: type});
};

/**
 *
 * @param {boolean} [shouldLog] - default true
 */
exports.log = function(shouldLog?:boolean) {
  if (_.isUndefined(shouldLog)) {
    shouldLog = true;
  }

  v1.log({
    level: shouldLog ? 'INFO' : 'OFF',
  });
};

/*
exports.googleAnalyticsCustomVariableScope = function() {
  // TODO(tyler)
};
*/

/*
exports.integrationPrefix = function() {
  // TODO(tyler)
};
*/

/**
 *
 * @param {boolean} [shouldOptOut] - default true
 */
exports.optOut = function(shouldOptOut?:boolean) {
  if (_.isUndefined(shouldOptOut)) {
    shouldOptOut = true;
  }

  v1.optOut({
    isOptOut: shouldOptOut,
  });
};

/*
exports.removeFromAllAudiences = function() {
  // TODO(tyler)
};
*/

/*
exports.sc_activate = function() {
  // TODO(tyler)
};
*/

/*
exports.sc_svar = function() {
  // TODO(tyler)
};
*/

/**
 *
 * @param {string} cookieDomain
 */
exports.setCookieDomain = function(cookieDomain:string) {
  // TODO(tyler): prepend with dot?
  v1.cookieDomain({
    cookieDomain: cookieDomain,
  });
};

/*
exports.skipPageTracking = function() {
  // Note: Removed; not supported in v1
};
*/

/**
 *
 * @param {number} cookieExpiration
 */
exports.setCookieExpiration = function(cookieExpiration:number) {
  v1.cookieExpiration({
    cookieExpirationDays: cookieExpiration,
  });
};

/**
 *
 * @param {string} dimensionId
 * @param {string} dimensionValue
 */
exports.setDimensionValue = function(dimensionId:string, dimensionValue:string) {
  var dimensions = {} as any;
  dimensions[dimensionId] = dimensionValue;

  v1.user({
    attributes: dimensions,
  });
};

/**
 *
 * @param {string} userId
 */
exports.setUserId = function(userId:string) {
  v1.user({
    userId: userId,
  });
};

/**
 *
 * @param {string} ga4UserId
 */
exports.setGA4UserId = function(ga4UserId:string) {
  v1.ga4User({
    ga4UserId: ga4UserId,
  });
};

exports.storeThirdPartyData = function(thirdPartyId, thirdPartyData) {
  v1.dataFromSource({
    source: thirdPartyId,
    data: thirdPartyData,
  });
};

/**
 * Tracks a custom event using all registered AnalyticsTrackers
 * @param {string} eventName
 * @param {Object|number} [revenueOrOptions]
 */
exports.trackEvent = function(eventName:string, revenueOrOptions?:any|number) {
  v1.event({
    eventName: eventName,
    tags: fixRevenueOptions(revenueOrOptions),
  });
};

/**
 * Processes goal's revenue value, if provided, and returns it as a field in an object.
 *
 * Ported from [tracker@533d91f7](https://github.com/optimizely/optimizely/blob/533d91f731f2abb91e927cbdbe4e1f67ca4972cc/src/www/js/client/tracker.js)
 *
 * @param {string|number|Object} [revenueOrOptions] A number or an options object with a 'revenue' property,
 *                                                   if revenue value provided.
 * @returns {Object|null} Options object with a .revenue property if revenue value provided;
 *                        any other options from revenueOrOptions would be preserved and accessible
 *                        via string notation.
 * @private
 */
function fixRevenueOptions(revenueOrOptions?:string|number|any): any|null {
  var options = {} as any;
  var revenueValue;

  // Get revenueValue, if specified in the api call
  if (revenueOrOptions) {
    if (isNumberLike(revenueOrOptions)) {
      revenueValue = Number(revenueOrOptions);
    }
    else if (typeof revenueOrOptions === 'object') {
      options = /** @type {Object} */ _.extend({}, revenueOrOptions);
      if ('revenue' in options) {
        if (isNumberLike(options['revenue'])) {
          revenueValue = Number(options['revenue']);
          delete options['revenue'];
        } else {
          // We have a bad revenue value specified.
          throw new Error('tracker: ' + 'Revenue value ' + options['revenue'] + 'not a number.');
        }
      }
    } else {
      throw new Error('tracker: ' + 'Revenue argument ' + revenueOrOptions + 'not a number.');
    }
  }

  // Update revenue value.
  if (!_.isUndefined(revenueValue)) {
    options.revenue = revenueValue;
  }

  return options;
}

function isNumberLike(obj) {
  return _.isNumber(obj) || (_.isString(obj) && Number(obj) == obj); // eslint-disable-line eqeqeq
}
